import { render, staticRenderFns } from "./EmptyDashboardState.vue?vue&type=template&id=24e7cff0&scoped=true"
import script from "./EmptyDashboardState.vue?vue&type=script&lang=js"
export * from "./EmptyDashboardState.vue?vue&type=script&lang=js"
import style0 from "./EmptyDashboardState.vue?vue&type=style&index=0&id=24e7cff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7cff0",
  null
  
)

export default component.exports